export const MACRO_ECON_VAR_DATA_SRC = "macro_econ_var_data_src"
export const MACRO_ECON_DATA = "macro_econ_data"
export const MACRO_ECON_PRODUCT_FILTER = "macro_econ_product_filter"
export const MACRO_ECON_CHECK_DATA = "macro_econ_check_data"